export default __webpack_public_path__ + "img/b39a1e9adedb8121c799d44469282511.png";